module.exports = __webpack_public_path__ + "static/media/stomach.62b8f8a3.svg";